export default function Bar({ pct, color, h = 5 }) {
  return (
    <div className="rounded-full overflow-hidden" style={{ background: '#EDECEA', height: h }}>
      <div
        className="rounded-full transition-all duration-500"
        style={{ width: `${Math.min(pct, 100)}%`, background: color, height: '100%' }}
      />
    </div>
  );
}
